import preload from '../../helpers/preload-electron'

preload()
